import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectBrokerConsultantBannerAvailable } from '../../selectors/brokerConsultantBanner';
import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { useApplicationContext } from '../../utils/applicationContext';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { BrokerConsultantBannerContainer } from '../BrokerConsultantBannerContainer';
import { NewbuildingPrizeBannerContainer } from '../NewbuildingPrizeBannerContainer';
import { getRandomBoolean } from '../../selectors/getRandomBoolean';

type TRotatedBanners = 'consultant' | 'prize';

export const BannerContainer = () => {
  const { config } = useApplicationContext();
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);
  const isBrokerConsultantBannerAvailable = useSelector(selectBrokerConsultantBannerAvailable);
  const randomBoolean = useSelector(getRandomBoolean);
  const isPrizeBannerEnabled = config.get<boolean>('Newbuilding.PrizeBanner.Enabled') || false;

  const rotatingBanner: TRotatedBanners | null = React.useMemo(() => {
    const banners: Array<TRotatedBanners> = [];

    if (isPrizeBannerEnabled) {
      banners.push('prize');
    }

    if (isBrokerConsultantBannerAvailable) {
      banners.push('consultant');
    }

    if (banners.length === 0) {
      return null;
    }

    if (banners.length === 1) {
      return banners[0];
    }

    return randomBoolean ? banners[0] : banners[1];
  }, [randomBoolean, isPrizeBannerEnabled, isBrokerConsultantBannerAvailable]);

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (rotatingBanner === 'prize') {
    return <NewbuildingPrizeBannerContainer />;
  }

  if (rotatingBanner === 'consultant') {
    return <BrokerConsultantBannerContainer />;
  }

  return null;
};
